import Btn from '@app/lui2/Btn';

import ModalContainer from './ModalContainer';
import {Subtitle, Title} from './styles';

interface Props {
  onCancel: () => void;
  onSubmit: () => void;
  buttonText?: string;
}

const DEFAULT_BUTTON_TEXT = 'Cancel Send & Log In';

const LogInPrompt = ({onCancel, onSubmit, buttonText}: Props) => {
  return (
    <ModalContainer
      footerChildren={
        <>
          <Btn onClick={onSubmit}>Send Email</Btn>
          {/* TODO: handle some type of login here? */}
          <Btn onClick={onCancel} variant="filled" color="primary">
            {buttonText || DEFAULT_BUTTON_TEXT}
          </Btn>
        </>
      }
    >
      <Title>Sign in to Loxo</Title>
      <Subtitle>
        Please sign in to the Loxo Microsoft Add-in to customize email syncing.
      </Subtitle>
    </ModalContainer>
  );
};

export default LogInPrompt;
